import { h } from 'preact'
import Phrase from '../../../libs/translationsUtils/phrase'
import { DoSearch } from './'

interface Props {
  inputValue: string
  hasResults: boolean
  doSearch: DoSearch
}

const HitContainerHeader = ({ inputValue, hasResults, doSearch }: Props) =>
  !hasResults
    ? <div className='algolia-hit-container__header'>
      <a onClick={() => doSearch(inputValue)} className='algolia-search-submit-link'>
        <span className='algolia-hit-container__header-text'>
          {
            inputValue
              ? (
                  hasResults
                    ? <Phrase p='live.search.search.text' />
                    : <Phrase p='live.search.no.result.found.text' />
                )
              : <Phrase p='live.search.trending.text' />
          }
        </span>
        {' '}
        {inputValue}
      </a>
    </div>
    : null

export default HitContainerHeader
